import { Component } from '@theme/component';

const DAY = 24 * 60 * 60 * 1000;

/**
 * Simulated product activity; no customer or order data is fetched.
 * @extends {Component<{soldCount?: HTMLElement, viewerCount?: HTMLElement}>}
 */
class ProductTrustBadges extends Component {
  /** @type {ReturnType<typeof setInterval> | undefined} */
  #timer;
  #startedAt = Date.now();
  #viewers = 27;
  #seed = 0;
  #productId;

  connectedCallback() {
    super.connectedCallback();
    this.#syncProduct();
    this.#render();
    clearInterval(this.#timer);
    this.#timer = setInterval(() => {
      if (document.hidden) return;
      // Pick a different count each time, within a small demo range.
      this.#viewers = 18 + ((this.#viewers - 18 + 1 + Math.floor(Math.random() * 17)) % 18);
      this.#render();
    }, 6000);
  }

  updatedCallback() {
    super.updatedCallback();
    this.#syncProduct();
    this.#render();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    clearInterval(this.#timer);
  }

  #syncProduct() {
    if (this.#productId === this.dataset.productId) return;
    this.#productId = this.dataset.productId;
    this.#seed = Number(this.dataset.activitySeed) || 0;
    this.#viewers = 18 + ((this.#seed * 7) % 18);
    this.#startedAt = Date.now();
    this.#restoreStart();
  }

  #restoreStart() {
    const key = `skinishini:demo-activity:${this.dataset.productId}`;
    try {
      const saved = Number(localStorage.getItem(key));
      this.#startedAt = Number.isFinite(saved) && saved > 0 && saved <= Date.now() ? saved : Date.now();
      localStorage.setItem(key, String(this.#startedAt));
    } catch {
      // Storage may be blocked; retain a working count for this page visit.
    }
  }

  #render() {
    const elapsedDays = Math.max(0, Math.floor((Date.now() - this.#startedAt) / DAY));
    // Product-specific starting value, varying every 24 hours (range 30–64).
    const sold = 30 + ((this.#seed + elapsedDays * 11) % 35);
    const formatter = new Intl.NumberFormat(document.documentElement.lang || 'en');
    if (this.refs.soldCount) this.refs.soldCount.textContent = formatter.format(sold);
    if (this.refs.viewerCount) this.refs.viewerCount.textContent = formatter.format(this.#viewers);
  }
}

if (!customElements.get('product-trust-badges')) {
  customElements.define('product-trust-badges', ProductTrustBadges);
}
